import React from 'react'
import {Navbar, Container} from 'react-bootstrap';

function WoltersNavbar({navData}) {
    
    const {sections} = navData || {};
    //eslint-disable-next-line no-unused-vars
    const [navbar_header, navbar_left, navbar_right, dropdown_menu] = sections || []; 

    const {links: navbar_links} = navbar_header || [];
    const [navbar_links_obj] = navbar_links || [];
    const {href: navbar_href, src: navbar_src} = navbar_links_obj || '';
    
    const {links: dropdown_links} = dropdown_menu || [];

    let logout = ''

    if(dropdown_links && dropdown_links.length) {
        const last_url = dropdown_links[dropdown_links.length-1]
        const {href: logout_href} = last_url || ''
        logout = logout_href
    }


  return (
    <Navbar variant="dark"className="navbar-custom navbar-inverse" id="navbar" expand="md">
        <Container>
            <Navbar.Brand href={navbar_href} className="navbar-header">
                <img src={navbar_src} alt='Specprawnik.pl'/>
            </Navbar.Brand>
            <a href={logout} id="wolters-logout">Wyloguj</a>
        </Container>
    </Navbar>
  )
}

export default WoltersNavbar